module.exports = __webpack_public_path__ + "static/media/f-2-mes-logo.b2b8c90f.svg";